import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { useSelector } from 'react-redux';

export const NotificationComponent = ({ response, transferType }) => {
  // Assuming filteredOptions is already computed and available
  // You would replace this with your actual filteredOptions logic
  var book = null;

  const createBookingResponse = useSelector(state => state.createBooking);
  // const combinations = useSelector((state) => state.mixedProduct.combinations);
  const transferTypeCodeToMatch = createBookingResponse.basket.transfers[0].transferType.code;

  const matchedOption = createBookingResponse.basket.options.find(option => option.transferTypeCode === transferTypeCodeToMatch);


  book = matchedOption ? !(matchedOption.book) : false;
  // console.log("notification check", book)

  // Mixed Product
  // const outboundMatch = combinations.find(combination =>
  //   combination.outbound.transferTypeCode === transferTypeCodeToMatch
  // );
  
  // const outboundBook = outboundMatch ? outboundMatch.outbound.book : null;

  // const inboundMatch = combinations.find(combination =>
  //   combination.inbound.transferTypeCode === transferTypeCodeToMatch
  // );
  
  // const inboundBook = inboundMatch ? inboundMatch.inbound.book : null;

  

  let showCustomNotification = book;
  // console.log("notification check 2", showCustomNotification)
  let hasNotifications;
  let hasPointsAppliedNotification;
  // Assuming 'response' with combinations
  if (response.basket.transfers.length > 1 && (response.basket.transfers[0].transferType.code !== response.basket.transfers[1].transferType.code)) {
    
   showCustomNotification = !(response.basket.transfers[0].transferType.code !== response.basket.transfers[1].transferType.code);
   hasNotifications = response.notifications && response.notifications.length > 0;
   hasPointsAppliedNotification = response.notifications.some(notification =>
    notification.type === "pop-up" && notification.validation_field === "pointsApplied"
  ) ? false : true;
  }
  // console.log("notification check 3", showCustomNotification)

  return (
    <>
      {showCustomNotification  ? (
        <Paper style={{ backgroundColor: '#DFF0D8', padding: 16, margin: '16px 0', color: '#3C763D' }}>
          <Typography variant="h6" gutterBottom>
            Update - Important Booking Information!
          </Typography>
          <List>
            <ListItem>
              <Typography variant="body1">
              Based on your travel requirements, we can't 100% confirm your booking right away. We just need to check availability for your request. This could be because of the travel dates, or the amount of luggage you have requested, for example.
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="body1">
              Please select the button below to submit your request.  Our team will look into this and get back to you as soon as possible.
              </Typography>
            </ListItem>
          </List>
        </Paper>
      ) : hasNotifications && hasPointsAppliedNotification ? (

        <Paper style={{ backgroundColor: '#DFF0D8', padding: 16, margin: '16px 0', color: '#3C763D' }}>
          <Typography variant="h6" gutterBottom>
            Update - Important Booking Information!
          </Typography>
          <List>
            <ListItem>
              <Typography variant="body1">
                The price has changed for your transfer as you have amended the amount of luggage or requested an additional optional extra.  Please make note of this price change before proceeding to payment.
              </Typography>
            </ListItem>

          </List>
        </Paper>

      ) : null}
    </>
  );
};

export default NotificationComponent;
